import { Link } from "react-router";
import forestArtwork from "../assets/greenwood-forest-terminal-tree.jpg";
import "./not-found.css";

export function NotFoundPage() {
  return (
    <main id="main-content" className="not-found-page" tabIndex={-1} aria-labelledby="not-found-title">
      <section className="not-found-card">
        <div className="not-found-artwork" aria-hidden="true">
          <img src={forestArtwork} alt="" />
          <span className="not-found-field-note">MERKLEWOOD field notes · Uncharted trail</span>
        </div>
        <div className="not-found-copy">
          <div className="not-found-brand"><img src="/logo.jpg" alt="" /> MERKLEWOOD</div>
          <p className="not-found-code">404 <span>/ Page not found</span></p>
          <h1 id="not-found-title">This trail ends here.</h1>
          <p>The page you're looking for may have moved, or the path doesn't exist. Head back to familiar ground.</p>
          <Link className="not-found-return" to="/">Back to terminal <span aria-hidden="true">↗</span></Link>
          <span className="not-found-footer">The forest is still here. Let's find your way back.</span>
        </div>
      </section>
    </main>
  );
}
